export function ViewChildren(selector: string): PropertyDecorator {
  return (target: Object, propertyKey: string): void => {
    Object.defineProperty(target.constructor.prototype, propertyKey, {
      get: function(): HTMLElement[] | undefined {
        return Array.from(this['querySelectorAll'](selector));
      },
    });
  };
}
